import { render, staticRenderFns } from "./Fold.vue?vue&type=template&id=28ea7b72&"
import script from "./Fold.vue?vue&type=script&lang=js&"
export * from "./Fold.vue?vue&type=script&lang=js&"
import style0 from "./Fold.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports